import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { ServiceError, getApiErrorStatus } from '@/utils/apiError'
import { CEP_LOOKUP_UNAVAILABLE_MESSAGE, CEP_NOT_FOUND_MESSAGE } from './CepService'

export interface AddressResponse {
  zipCode: string
  street: string
  complement: string
  neighborhood: string
  city: string
  state: string
  ibge?: string
}

export default class ConsultingAddressService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/consulting-address'
  }

  /**
   * Busca de endereço por CEP via backend (que consulta o ViaCEP).
   *
   * O backend responde 404 para CEP inexistente e 5xx quando o ViaCEP não
   * responde. A falha é de um serviço externo e o formulário segue no manual,
   * então as mensagens orientam o preenchimento manual em vez de repassar o
   * genérico "tente novamente": 404 → CEP não encontrado; rede, timeout e 5xx →
   * serviço indisponível; demais 4xx (validação do CEP) → mensagem do backend.
   */
  async getAddressByCep(zipCode: string): Promise<AddressResponse> {
    const cleanCep = zipCode.replace(/\D/g, '')
    try {
      // 2º argumento do `request.get` já é o objeto de query params.
      const { data } = await request.get<AddressResponse>(this.getCompletePath(''), {
        zipCode: cleanCep
      })

      return data
    } catch (e) {
      const status = getApiErrorStatus(e)
      if (status === 404) throw new ServiceError(CEP_NOT_FOUND_MESSAGE, e)
      if (typeof status === 'number' && status >= 400 && status < 500) {
        throw this.handleError(e, CEP_NOT_FOUND_MESSAGE)
      }
      throw new ServiceError(CEP_LOOKUP_UNAVAILABLE_MESSAGE, e)
    }
  }
}
